import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWallLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowWallLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M4 4V20H2V4H4ZM12.6642 7.75L9.41422 11H22V13H9.41421L12.6642 16.25L11.25 17.6642L5.58579 12L11.25 6.33579L12.6642 7.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWallLeft;
